import { pushToArray } from './common/helpers';
export const stampEventDeliveryTags = (events, tags) => {
  events.forEach(event => pushToArray(event.library_delivery, tags));
};